import React from 'react';
import { Modal as RNModal, View, Pressable, ScrollView } from 'react-native';
import { useTheme } from '../theme';
import Button from './Button';
import Icon from './Icon';
import Txt from './Txt';

interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'wide' | 'full';
}

const WIDTH: Record<NonNullable<ModalProps['size']>, number | '96%'> = {
  sm: 380, md: 520, wide: 760, full: '96%',
};

/** RN port of theme.css's .t-modal — centered dialog over a scrim, head/body/foot. */
export default function Modal({ title, onClose, children, footer, size = 'md' }: ModalProps) {
  const t = useTheme();
  return (
    <RNModal visible transparent animationType="fade" onRequestClose={onClose}>
      <Pressable
        onPress={onClose}
        style={{ flex: 1, backgroundColor: 'rgba(16,24,40,0.42)', alignItems: 'center', justifyContent: 'center', padding: 24 }}
      >
        <Pressable
          onPress={() => {}}
          style={{
            width: WIDTH[size],
            maxWidth: '100%',
            maxHeight: '90%',
            backgroundColor: t.colors.card,
            borderRadius: t.radii[4],
            overflow: 'hidden',
            ...t.shadows.lg,
          }}
        >
          <View
            style={{
              paddingVertical: 14,
              paddingHorizontal: 18,
              borderBottomWidth: 1,
              borderBottomColor: t.colors.line,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 8,
            }}
          >
            <Txt size="lg" weight="semibold">{title}</Txt>
            <Button variant="ghost" size="sm" icon onPress={onClose}>
              <Icon name="x" size={14} color={t.colors.ink2} />
            </Button>
          </View>
          <ScrollView style={{ flexGrow: 0 }} contentContainerStyle={{ padding: 18 }}>
            {children}
          </ScrollView>
          {footer && (
            <View
              style={{
                paddingVertical: 12,
                paddingHorizontal: 18,
                borderTopWidth: 1,
                borderTopColor: t.colors.line,
                backgroundColor: t.colors.paper2,
                flexDirection: 'row',
                justifyContent: 'flex-end',
                gap: 8,
              }}
            >
              {footer}
            </View>
          )}
        </Pressable>
      </Pressable>
    </RNModal>
  );
}
